import styled from "styled-components";

export const InfoForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 15px;
  hr {
    width: 100%;
    border: 0.5px solid #e8e8e8;
  }

  /* .hr-solid {
    border: 0px solid #e8e8e8;
  } */
`;

export const InfoDetail = styled.div`
  margin-bottom: 10px;
  margin-top: 10px;
`;

export const InfoSpan = styled.div`
  color: ${(props) => props.theme.colors.primary};
  font-size: 1.4rem;
  font-weight: 500;
  margin-bottom: 10px;
`;

export const WithDrawalInfoSpan = styled.div`
  color: ${(props) => props.theme.colors.gray};
  font-size: 1.5rem;
  font-weight: 500;
  margin-bottom: 10px;
  display: flex;
  flex-direction: row-reverse;
`;

export const InfoGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
export const Infointo = styled.div`
  color: ${(props) => props.theme.colors.gray};
  font-size: 1.3rem;
  font-weight: 400;
  margin-top: 10px;
  margin-bottom: 10px;
  width: 20%;
`;

export const InfoContext = styled.div<any>`
  font-size: 1.6rem;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  word-break: break-all;

  &.idText {
    width: 60%;
  }
  /* display: block;
  margin: 0 auto; */
  /* margin-left: auto; */
`;

export const InfoFunction = styled.div`
  color: ${(props) => props.theme.colors.primary};
  font-size: 1.6rem;
  font-weight: 600;
  display: flex;
  margin-left: auto;
`;

// export const IconLine = styled.div`
//   width: 30%;
//   border: 1px;
//   border-color: lightgray;
// `;
